import { OnInit, Component, ViewChild, Output, EventEmitter, Input, ChangeDetectorRef } from "@angular/core";
import { first, Subscription } from "rxjs";
import { ClaimsService } from "../../_services/common/claims.service";
import { TranslateService } from "@ngx-translate/core";
import { Claims } from "../../_models/common/claims";
import { AppGridComponent } from "../../shared/grid/grid-component/grid.component";
import { ColDef } from "ag-grid-community";
import { GridConfig } from "../../_models/common/grid/grid-config";
import { ExpenseCategoryInExpenseRequest, ExpenseCategoryRequest, ExpenseCategoryRequestInfo } from "src/app/_models/claimant/expense-category-request";
import { ExpenseCategoryService } from "src/app/_services";
import { SelectVendorCategoriesInputModel, SelectVendorCategoriesOutputModel } from "src/app/_models/vendor/vendor.model";
import { IManageCategoryListRequest, ManageCategoryListRequest } from "src/app/_models/manage-category/manage-category-list-request";
import { ApiRequest, SetupTypeEnum } from "src/app/_models";
import { environment } from "src/environments/environment";
import { ManageCategoryService } from "src/app/_services/manage-category/manage-category.service";
import { BaseCategoryTypeEnum } from "src/app/_models";
import { AlertPanelModel } from "src/app/_models/common/alertPanelModel";

@Component({
  selector: "vendor-category-list-panel",
  templateUrl: "./categories-list-panel.component.html",
  standalone: false
})

export class VendorCategoriesListPanelComponent implements OnInit {

  @ViewChild('vendorCategoriesGrid') gridComponent: AppGridComponent;
  @Input() inputData: SelectVendorCategoriesInputModel;
  @Output() closePanelEvent = new EventEmitter<boolean>();
  @Output() submitPanelEvent = new EventEmitter<any>();

  claimsSubscription: Subscription;
  userActionEventSubscription: Subscription;
  claims: Claims;
  gridColumnDefs: ColDef[];
  gridConfigItems: GridConfig;
  gridData: any[] = [];
  defaultSortColumn: string = 'expenseCategoryName';
  defaultSortOrder: string = 'asc';

  hasFormChanges: boolean = false;
  expenseCategoryList: any[];
  expenseCategoryRequest: ExpenseCategoryRequest;
  expenseCategoryInExpenseRequest: ExpenseCategoryInExpenseRequest;
  checkedCategoryList = [];
  selectedCategoryIds: number[] = [];
  outputModel: SelectVendorCategoriesOutputModel = new SelectVendorCategoriesOutputModel();
  manageCategoryResponse: any;
  isAddVendorCategory: boolean = false;
  categoryFormModel: any = {};
  vatRateItems: any[] = [];
   alertPanelModel = new AlertPanelModel(
    false,
    "",
    [""],
    "",
    "",
    true,
    this.translate.instant("please_review_or_confirm")
  );
  constructor(
    private claimsService: ClaimsService,
    private translate: TranslateService,
    private expenseCategoryService: ExpenseCategoryService,
    private cdr: ChangeDetectorRef,
    private manageCategoryService: ManageCategoryService
  ) {
    this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
  }

  ngOnInit(): void {
    this.fnInitialiseGrid();
    this.selectedCategoryIds = this.inputData.assignedCategoryIdsList.length > 0 ? this.inputData.assignedCategoryIdsList.map(a => a.categoryId) : [];
    this.fnGetOrgManageCatList();
  }

 fnClosePanel() {
        if (this.hasFormChanges) {
            this.alertPanelModel = new AlertPanelModel(
        true,
        this.translate.instant("alert_info"),
        [this.translate.instant("business_purpose_discard_msg")],
        this.translate.instant("cancel"),
        this.translate.instant("label_confirm"),
        true,
        this.translate.instant("please_review_or_confirm")
      );
        }
        else {
            this.closePanelEvent.emit(true);
        }
    }

  fnInitialiseGrid() {
    this.fnCreateColumnDefs();
    this.fnGetGridConfigItems();
    setTimeout(() => {
      this.gridComponent.initializeGrid();
      this.cdr.detectChanges();
    }, 200);

  }

  fnCreateColumnDefs() {
    this.gridColumnDefs = [
      {
        headerName: this.translate.instant('category_name'),
        field: 'expenseCategoryName',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100
      },
    ]

  }

  fnGetGridConfigItems() {
    this.gridConfigItems = new GridConfig(
      false,
      true,
      this.defaultSortColumn,
      'orgExpenseCategoryId',
      0,
      true,
      [],
      true,
      true,
      true,
      null,
      this.defaultSortOrder,
      40,
      this.translate.instant('no_data_availabe'),
      null,
      null,
      false,
      false,
      '',
      '',
      false
    );
  }


  fnOnGridCellClick(params) {
    switch (params.column.colId) {
      case 'selected':
        this.checkedCategoryList = this.gridData.filter(a => a.selected)
        this.hasFormChanges = true;
        break;
    }
  }
  loadExpenseCategory() {

    this.expenseCategoryInExpenseRequest = new ExpenseCategoryInExpenseRequest();
    this.expenseCategoryInExpenseRequest.WebApiName =
      "ExpenseCategoryInExpense";
    this.expenseCategoryInExpenseRequest.RequestId = "1";
    this.expenseCategoryInExpenseRequest.WebApiVersion = 1;
    this.expenseCategoryInExpenseRequest.RequestInfo = this.claims.OrgId;

    this.expenseCategoryRequest = new ExpenseCategoryRequest();
    this.expenseCategoryRequest.WebApiName = "OrgExpenseCategory";
    this.expenseCategoryRequest.RequestId = 1;
    this.expenseCategoryRequest.WebApiVersion = 1;
    this.expenseCategoryRequest.RequestInfo = new ExpenseCategoryRequestInfo();
    this.expenseCategoryRequest.RequestInfo.OrgId = this.claims.OrgId;
    this.expenseCategoryRequest.RequestInfo.LastUpdatedTimeStamp = 0;
    this.expenseCategoryRequest.RequestInfo.IsForCreditCardExpense = false;

    this.expenseCategoryService
      .getOrgExpenseCategoryInExpense(this.expenseCategoryInExpenseRequest)
      .pipe(first())
      .subscribe(
        (expenseCategoryInExpense) => {
          this.expenseCategoryService
            .getOrgExpenseCategory(this.expenseCategoryRequest)
            .pipe(first())
            .subscribe(
              (data) => {
                this.expenseCategoryList = data.responseInfo.categories.filter(
                  (i) =>
                    i.isActive === true ||
                    expenseCategoryInExpense.responseInfo.filter(
                      (x) => x == i.orgExpenseCategoryId
                    ).length > 0
                );

                this.expenseCategoryList.sort((a, b) =>
                  a.expenseCategoryName > b.expenseCategoryName ? 1 : -1
                );
                this.gridData = this.expenseCategoryList;
                this.gridData.forEach((item) => {
                  if (this.selectedCategoryIds.includes(item.orgExpenseCategoryId)) {
                    item.selected = true;
                  } else {
                    item.selected = false;
                  }
                });
                setTimeout(() => {
                  this.gridComponent.refreshGridData();
                  this.cdr.detectChanges();
                }, 300);

              },
              (error) => { }
            );
        },
        (error) => { }
      );
  }

  fnGetOrgManageCatList() {
    let request = new ApiRequest<IManageCategoryListRequest>("SoloGetOrgVendorManageCatList", environment.applicationVersion, environment.requestId);
    let requestInfo = new ManageCategoryListRequest(0, '', false, 0, 0, 200);

    requestInfo.action = 0;
    requestInfo.SetupType = SetupTypeEnum.Vendor;
    request.requestInfo = requestInfo;

    this.manageCategoryService.SoloGetOrgVendorManageCatList(request)
      .subscribe((response: any) => {
        if (response != null) {
          this.manageCategoryResponse = response;
          this.expenseCategoryList = response.manageCategoryList;
          this.categoryFormModel.TaxRateMasterList = response.taxRateMasterResponse ? response.taxRateMasterResponse.filter(a => a.isActive && !a.isExpiredRate) : [];
          this.vatRateItems = [];
          this.categoryFormModel.TaxRateMasterList.forEach(item => {
            this.vatRateItems.push(
              {
                id: item.taxRateMasterId, value: (item.taxRate.toString() + ' %'),
                description: ''
              }
            )
          });

          this.categoryFormModel.vatRateItems = this.vatRateItems;

          this.gridData = this.expenseCategoryList.filter(a => a.isActive);
          this.gridData.forEach((item) => {
            if (this.selectedCategoryIds.includes(item.orgExpenseCategoryId)) {
              item.selected = true;
            } else {
              item.selected = false;
            }
          });
          setTimeout(() => {
            this.gridComponent.refreshGridData();
            this.cdr.detectChanges();
          }, 300);
          this.manageCategoryResponse.manageCategoryList = [];


          this.manageCategoryResponse.manageCategoryList.forEach(c => {
            if (c.baseCategoryId == BaseCategoryTypeEnum.Entertainment) {
              if (c.isTipsEnabled) {
                c.tooltip = this.translate.instant('tips_disable_info');
              }
              else {
                c.tooltip = this.translate.instant('tips_enable_info');
              }
            }
          });



          this.categoryFormModel.manageCategoryList = this.manageCategoryResponse.manageCategoryList;

        }
      });
  }

  fnOnGridCheckAll(isChecked) {
    this.checkedCategoryList = this.gridData.filter(a => a.selected)
        this.hasFormChanges = true;
  }
  fnOnSave() {
    this.outputModel.assignedCategoriesName = this.checkedCategoryList.length > 0 ? (this.checkedCategoryList.length == 1 ? this.translate.instant('one_category_assigned') : this.checkedCategoryList.length + " " + this.translate.instant('categories_assigned')) : null;
    this.outputModel.assignedCategoryIdsList = [];
    this.checkedCategoryList.forEach((item) => {
      var oldMapping = this.inputData.assignedCategoryIdsList.find(a => a.categoryId == item.orgExpenseCategoryId);
      this.outputModel.assignedCategoryIdsList.push({ categoryId: item.orgExpenseCategoryId });
    });
    this.submitPanelEvent.emit(this.outputModel);
  }

  fnOnAddCategory() {
    this.isAddVendorCategory = true;
  }

  fnOnCloseAddCategory() {
    this.fnGetOrgManageCatList();
    this.isAddVendorCategory = false;
  }
    alertPanelReceiver(returnValue) {
    if (returnValue) {
      this.closePanelEvent.emit(true);
    }
    else {
      this.alertPanelModel = new AlertPanelModel(
        false,
        "",
        [""],
        "",
        "",
        true,
        this.translate.instant("please_review_or_confirm")
      );
    }
  }
}
